import _classCallCheck from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var SequenceNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(SequenceNode, _DataFlowNode);

  var _super = _createSuper(SequenceNode);

  function SequenceNode(parent, params) {
    var _this;

    _classCallCheck(this, SequenceNode);

    _this = _super.call(this, parent);
    _this.params = params;
    return _this;
  }

  _createClass(SequenceNode, [{
    key: "clone",
    value: function clone() {
      return new SequenceNode(null, this.params);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      var _a;

      return new Set([(_a = this.params.as) !== null && _a !== void 0 ? _a : 'data']);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Hash ".concat(_hash(this.params));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign({
        type: 'sequence'
      }, this.params);
    }
  }]);

  return SequenceNode;
}(DataFlowNode);